import styled from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

const aspectRatio = 1.286
const maxHeight = '504px'

export const Container = styled.section`
  background: ${o => o.theme.color.deprecated.black.secondary};
  color: white;
  margin-bottom: 32px;
  text-align: center;

  ${fromMd} {
    align-items: center;
    display: flex;
    margin-bottom: 40px;
  }
`

export const ImageWrap = styled.div`
  height: 0;
  overflow: hidden;
  padding-top: calc(1 / ${aspectRatio} * 100%); /* for IE */
  padding-top: min(1 / ${aspectRatio} * 100%, ${maxHeight});
  position: relative;

  ${fromMd} {
    padding-top: calc(1 / ${aspectRatio} * 50%); /* for IE */
    padding-top: min(1 / ${aspectRatio} * 50%, ${maxHeight});
    width: 50%;
  }

  > img,
  > video {
    display: block;
    height: 100%;
    left: 0;
    object-fit: cover;
    font-family: 'object-fit: cover;';
    position: absolute;
    top: 0;
    width: 100%;
  }
`

export const TextWrap = styled.div`
  padding: 72px 40px;

  ${fromMd} {
    box-sizing: border-box;
    padding: 72px 45px;
    width: 50%;
  }

  button {
    background: transparent;
    border-color: white;

    &:hover {
      border-color: white;
    }
  }
`

export const Title = styled.h3`
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 5px;
  line-height: 1.25;
  margin-bottom: 24px;
  text-transform: uppercase;

  ${fromMd} {
    margin-bottom: 40px;
  }
`

export const Body = styled.p`
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.6px;
  line-height: 1.63;
  margin-bottom: 36px;

  ${fromMd} {
    margin-bottom: 40px;
  }
`
